import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { concertImageUrls, preloadImages } from './preload.ts'
import { CONCERTS, program } from './program.ts'
import './styles/global.css'

const container = document.getElementById('root')
if (!container) throw new Error('Fant ikke #root')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/**
 * Downloads the artist images for offline use, once, after the page has painted.
 *
 * After the `load` event and never before it: the images are the only part of the app
 * that is not already offline, and they are worth nothing if fetching them delays the
 * programme the user opened the app to read (R25). Guarded on `navigator.onLine`
 * because a run with no network would burn the retry on 88 certain failures.
 *
 * `storage.persist()` alongside, and deliberately not awaited: an unpersisted origin is
 * evicted first when the device runs low, which would quietly undo the download. WebKit
 * grants it to installed home-screen apps, which is exactly this app's install story.
 */
function warmOfflineCache() {
  if (!navigator.onLine) return
  void navigator.storage?.persist?.().catch(() => {})
  void preloadImages({
    urls: concertImageUrls(CONCERTS),
    // The snapshot's own timestamp: a refreshed programme re-runs the warm-up, an
    // unchanged one never asks twice.
    version: program.fetchedAt,
  }).catch(() => {})
}

if (document.readyState === 'complete') warmOfflineCache()
else window.addEventListener('load', warmOfflineCache, { once: true })
